import type { IntlShape } from "@formatjs/intl";
import { Typography } from "antd";
import React, { type CSSProperties } from "react";
import { connect } from "react-redux";
import type { RootState } from "../../app/store";

type NoDataProps = {
	intl: IntlShape;
	className?: string;
	style?: CSSProperties;
};

export const NoData = React.memo((props: NoDataProps) => {
	const { intl, className, style = {} } = props;
	return (
		<Typography.Text type="secondary" style={style} className={className}>
			{intl.formatMessage({ id: "common_no_data" })}
		</Typography.Text>
	);
});

export const NoDataConnected = connect((state: RootState) => ({
	intl: state.intl.datetimeIntl,
}))(NoData);
